import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { ClubModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

const { name, action, mutation } = ClubModuleConstant;

export default class ClubStore implements ltFramework.IClubStore {
	public getInitialData(): ltFramework.IClubDetails {
		return (Store.state as ltFramework.IStoreState).clubModule.clubDetails;
	}

	public initialize(): Promise<void> {
		return Store.dispatch(name + '/' + action.initialize);
	}

	public initializeClub(club?: ltFramework.IClubData): Promise<void> {
		return Store.dispatch(name + '/' + action.initializeClub, club);
	}

	public updateClub(club: ltFramework.IClubData): Promise<void> {
		return Store.dispatch(name + '/' + action.updateClub, club);
	}

	public listen(callback: (state: ltFramework.IClubDetails) => void): () => void {
		return Store.subscribe((payload: MutationPayload, state: ltFramework.IRootState) => {
			if (payload.type.includes(name + '/') && !payload.type.includes(mutation.setInitializing)) {
				// because listeners only want new club data
				callback((state as ltFramework.IStoreState).clubModule.clubDetails);
			}
		});
	}
}
